import { Theme } from '@mui/material';

import { AbgSxProps } from '@abg/typings';

export const totalAmountStyling: TotalAmountStyleParts = {
  amountWrapper: {
    display: 'flex',
    gap: '8px',
    alignItems: 'center',
  },
  carretButton: {
    padding: 0,
  },
  caretIcon: {
    width: '12px',
    height: '12px',
    cursor: 'pointer',
    lineHeight: 'initial',
  },
};

export const totalAmountWrapperStyling =
  (isModificationFlow: boolean): AbgSxProps =>
  (theme: Theme) => ({
    display: 'flex',
    // gap: '8px',
    flexDirection: {
      xs: 'column',
    },
    alignItems: {
      xs: 'flex-start',
      sm: 'flex-end',
    },
    order: {
      sm: 2,
      xs: 1,
    },
    ...(isModificationFlow && {
      [theme.breakpoints.down('sm')]: {
        gap: '0',
        alignItems: 'flex-start',
        flexDirection: 'column',
      },

      [theme.breakpoints.down(480)]: {
        flexDirection: 'column',
        alignItems: 'center',
        // gap: '8px',
      },
    }),
  });

export const totalAmountTextStyling: AbgSxProps = {
  paddingTop: '4px',
};

export const totalAmountPriceStyling: AbgSxProps = {
  ':hover': {
    cursor: 'pointer',
  },
};

export const checkoutMobileWrapperStyling: AbgSxProps = {
  display: 'flex',
  alignItems: 'flex-start',
  flexDirection: 'column',
  flexShrink: 1,
  minWidth: 0,
};

export const checkoutMobileTotalLabelStyling: AbgSxProps = {
  fontSize: '14px !important',
};

export const totalAmountWrapperBoxStyling = {
  display: 'flex',
  flexDirection: {
    xs: 'column',
    sm: 'row',
  },
  alignItems: {
    xs: 'flex-start',
    sm: 'center',
  },
  gap: {
    sm: '8px',
  },
};

export const priceDisclaimer = {
  color: '#736D6D',
  fontSize: '10px',
  fontWeight: 500,
};

type TotalAmountStyleParts = {
  amountWrapper: AbgSxProps;
  carretButton: AbgSxProps;
  caretIcon: AbgSxProps;
};
